import React from 'react';
import { formatCurrency } from './utils';

const StatCardMinis = ({ pvl, invoice_total, total_loss, percent_loss }) => {

  const statData = [
    { label: 'Current PVL', value: formatCurrency(pvl) },
    { label: 'Invoice Total', value: formatCurrency(invoice_total) },
    { label: 'Total Loss', value: formatCurrency(total_loss) },
    { label: '% of Loss', value: percent_loss },
  ];

  return (
    <div className="stat-card-container top-of-table">
      {statData.map((item, idx) => (
        <div className="stat-card-mini">
          <div className="stat-info-mini">
            <h3 className="stat-title-mini">{item.label}</h3>
            <p className="stat-value-mini">{item.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatCardMinis;
